import { Container, Typography, Grid, Box, Fade } from "@mui/material";
import {
  CalendarToday, Checklist, CleaningServices, KingBed
} from "@mui/icons-material";
import { useInView } from "react-intersection-observer";
import SectionHeader from "../components/SectionHeader";

const steps = [
  {
    icon: <CalendarToday fontSize="large" sx={{ color: "#FFFFFF" }} />,
    title: "Provide Details",
    description: "Fill out a short form with property info, guest checkout time, and any special requests.",
  },
  {
    icon: <Checklist fontSize="large" sx={{ color: "#FFFFFF" }} />,
    title: "Confirm Checklist",
    description: "We’ll confirm your booking, share our cleaning checklist, and align on any specifics.",
  },
  {
    icon: <CleaningServices fontSize="large" sx={{ color: "#FFFFFF" }} />,
    title: "We Clean",
    description: "Our verified cleaners follow the checklist and send photo proof after completion.",
  },
  {
    icon: <KingBed fontSize="large" sx={{ color: "#FFFFFF" }} />,
    title: "Impress Guests",
    description: "Your space is clean, staged, and ready for 5-star reviews — stress-free hosting!",
  },
];

interface StepsProps {
  bgcolor?: string;
}

function Steps({ bgcolor = "background.paper" }: StepsProps) {
  const { ref, inView } = useInView({
    triggerOnce: true, // only animate once
    threshold: 0.3,    // animate when 30% visible
  });
  return (
    <Box sx={{ width: "100%", bgcolor }}>
      <Container component="section" maxWidth="md" sx={{ py: 4, textAlign: "center", }} ref={ref}>
        <SectionHeader title="How It Works" />
        <Grid container spacing={4} justifyContent="center">
          {steps.map((step, index) => (
            <Grid item xs={12} sm={3} key={index}>
              <Fade in={inView} timeout={900 + index * 900}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 2,
                    px: 2,
                  }}
                >
                  {/* Icon inside a Circle */}
                  <Box
                    sx={{
                      width: 70,
                      height: 70,
                      borderRadius: "50%",
                      bgcolor: "#FF385C",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: 2,
                    }}
                  >
                    {step.icon}
                  </Box>

                  {/* Step Title */}
                  <Typography variant="h5" fontWeight="bold">
                    {step.title}
                  </Typography>

                  {/* Step Description */}
                  <Typography variant="body1" color="text.secondary">
                    {step.description}
                  </Typography>
                </Box>
              </Fade>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default Steps;